import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { AttendenceReportComponent } from './attendence-report/attendence-report.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '' , component:ListComponent
  },
  {
    path: 'add' , component : AddComponent
  },
  {
    path: 'edit/:id' , component : AddComponent
  },
  {
    path: 'reports' , component : AttendenceReportComponent,
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Management','HR'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmpAttendenceRoutingModule { }
